import {
    CLAPI
} from '../clchart/cl.api.js'
import { formatFloat } from '../clchart/cl.utils.js'
import * as DATAS from '../datas/transdata.js'
import * as COMMON from './common.res.js'

const FIELD_KBAR = {
    date: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    clr: 8,
    right: 9,
    bsflag: 10,
}

// {
//     "msec": 0,
//     "status": 1,
//     "agop": 2,
//     "open": 3,
//     "maxp": 4,
//     "minp": 5,
//     "newp": 6,
//     "stopmax": 7,
//     "stopmin": 8,
//     "summ": 9,
//     "sumv": 10
// }
export function concatKbar(curbar, nowbar) {
    const newbar = {
        fields: DATAS.fieldsToFieldsIndex(COMMON.newbar_fields),
        datas: [nowbar.infos]
    }
    console.log(newbar);
    
    const newbarMsec = CLAPI.Utils.strMsecToMTime(CLAPI.getData(newbar, 'msecstamp', 0))
    const curbarMsec = CLAPI.getData(curbar, 'msec', -1);
    if (newbarMsec > curbarMsec) {
        curbar.datas.push([
            CLAPI.Utils.strMsecToMTime(CLAPI.getData(newbar, 'msecstamp', 0)),
            '0',
            CLAPI.getData(newbar, 'agop', 0),
            CLAPI.getData(newbar, 'open', 0),
            CLAPI.getData(newbar, 'maxp', 0),
            CLAPI.getData(newbar, 'minp', 0),
            CLAPI.getData(newbar, 'newp', 0),
            0,0,
            CLAPI.getData(newbar, 'summ', 0) * 100,
            CLAPI.getData(newbar, 'sumv', 0) * 100,
        ])
    }
    console.log(curbar);
}
export function getKbar(indata, adjust) {
    let kbars = []
    for (let index = 0; index < indata.datas.length; index++) {
        let right = '0'
        let clr = 'red'
        if (parseFloat(CLAPI.getData(indata, 'open', index)) > parseFloat(CLAPI.getData(indata, 'newp', index))) {
            clr = 'green'
        }
        kbars.push(
            [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
            CLAPI.getData(indata, 'agop', index),
            CLAPI.getData(indata, 'open', index),
            CLAPI.getData(indata, 'maxp', index),
            CLAPI.getData(indata, 'minp', index),
            CLAPI.getData(indata, 'newp', index),
            CLAPI.getData(indata, 'sumv', index) / 100.0,
            CLAPI.getData(indata, 'summ', index) / 100.0,
                clr,
                right,
                '0'
            ])
    }
    let index = 0
    for (let aindex = 0; aindex < adjust.datas.length; aindex++) {
        const msec = CLAPI.Utils.strMsecToMTime(CLAPI.getData(adjust, 'msecstamp', aindex))
        const date = CLAPI.Utils.getMsecDate(msec)
        const flag = CLAPI.getData(adjust, 'bsflag', aindex)

        for (; index < kbars.length;) {
            // console.log(flag, date, kbars[index][0]);
            if (kbars[index][0] === date) {
                if (kbars[index][10] !== '0') {
                    console.log(kbars[index][10]);
                    if ((kbars[index][10] === 'ask' && flag === 'B') ||
                        (kbars[index][10] === 'bid' && flag === 'S')) {
                        kbars[index][10] = 'fbox'
                    }
                }
                else {
                    kbars[index][10] = flag === 'B' ? 'bid' : 'ask'
                }
                break;
            }
            else {
                index++
            }
        }
    }
    return {
        fields: FIELD_KBAR,
        datas: kbars
    }
}

const FIELD_MINU = {
    msec: 0, // 按交易时间的分钟索引
    open: 1,
    maxp: 2,
    minp: 3,
    newp: 4,
    sumv: 5,
    summ: 6,
    curv: 7,
    curm: 8,
    avgp: 9,
    index: 10,
    bsflag: 11,
}

export function cloneMinute(src, dst, index) {
    dst[0] = src[0]
    dst[1] = src[1]
    dst[2] = src[2]
    dst[3] = src[3]
    dst[4] = src[4]
    dst[5] = src[5]
    dst[6] = src[6]
    dst[7] = 0
    dst[8] = 0
    dst[9] = src[9]
    dst[11] = index % 240
}
export function getMinute(indata, curkey, adjusts, curdate) {
    let minus = []
    for (let km = 0; km < 240; km++) {
        minus.push([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1, '0'])
    }
    let agominu = -1
    let curv = 0
    let curm = 0
    for (let index = 0; index < indata.datas.length; index++) {
        let curminu = CLAPI.Utils.getTradeMsecToIndex(indata.datas[index][0], CLAPI.STOCK_TRADETIME);
        if (curminu > 239) {
            curminu = 239
        }
        if (agominu >= 0) {
            curv = CLAPI.getData(indata, 'sumv', index) - minus[agominu][5]
            curm = CLAPI.getData(indata, 'summ', index) - minus[agominu][6]
        } else {
            curv = CLAPI.getData(indata, 'sumv', index)
            curm = CLAPI.getData(indata, 'summ', index)
        }

        const nowv = minus[curminu]
        nowv[0] = CLAPI.getData(indata, 'msec', index)
        nowv[1] = CLAPI.getData(indata, 'open', index)
        nowv[2] = CLAPI.getData(indata, 'maxp', index)
        nowv[3] = CLAPI.getData(indata, 'minp', index)
        nowv[4] = CLAPI.getData(indata, 'newp', index)

        nowv[5] = CLAPI.getData(indata, 'sumv', index)
        nowv[6] = CLAPI.getData(indata, 'summ', index)
        nowv[7] = curv
        nowv[8] = curm
        nowv[9] = CLAPI.getData(indata, 'summ', index) / CLAPI.getData(indata, 'sumv', index)

        nowv[10] = curminu
        agominu = curminu
    }
    // 处理没有数据的分钟线
    for (let index = 0; index < minus.length; index++) {
        if (minus[index][10] === -1) {
            if (index % 240 === 0) {
                // 向后找
                for (let fi = index + 1; fi < minus.length; fi++) {
                    if (minus[fi][10] !== -1) {
                        cloneMinute(minus[fi], minus[index], index)
                        break
                    }
                }
            }
            else {
                // 向前找
                for (let fi = index - 1; fi >= 0; fi--) {
                    if (minus[fi][10] !== -1) {
                        cloneMinute(minus[fi], minus[index], index)
                        break
                    }
                }
            }
        }
    }
    console.log(adjusts);

    if (adjusts.datas !== undefined) {
        for (let index = 0; index < adjusts.datas.length; index++) {
            const nowmsec = CLAPI.getData(adjusts, 'msecstamp', index)
            if (curdate !== undefined) {
                if (CLAPI.Utils.strMsecTostrDate(nowmsec) !== curdate) {
                    continue
                }
            }
            if (CLAPI.getData(adjusts, 'code', index) === curkey) {
                const msec = CLAPI.Utils.strMsecToMTime(nowmsec)
                const curminu = CLAPI.Utils.getTradeMsecToIndex(msec, CLAPI.STOCK_TRADETIME);
                const nowv = minus[curminu]
                nowv[11] = CLAPI.getData(adjusts, 'bsflag', index) === 'B' ? 'bid' : 'ask'
                console.log(nowv);

            }
        }
    }
    return {
        fields: FIELD_MINU,
        datas: minus
    }
}

const adjust_fields = 'status,curprc,basket_idx,command,bsflag,curvol,simvol,adjvol,curfee,style,fsort,frisk,fhold,scale'
const ARRAY_ADJUST = DATAS.strsToArray(adjust_fields);

const FIELD_ADJUST = DATAS.fieldsMergeFieldsIndex('index,code,name,date,time,typename,dirname,dirclr', adjust_fields)

function transStyle(style) {
    let name = style
    switch (style) {
        case 'N':
            name = '正常'
            break;
        case 'P':
            name = '减仓'
            break;
        case 'T':
            name = '-'
            break;
        case 'R':
            name = '风控'
            break;
        case 'G':
            name = '止盈'
            break;
        case 'L':
            name = '止损'
            break;
        case 'Y':
            name = '移损'
            break;
        case 'D':
            name = '时减'
            break;
        case 'M':
            name = '强卖'
            break;
        case 'F':
            name = '出池'
            break;
        default:
            break;
    }
    return name
}
export function getInfoAdjust(indata, keyInfo) {
    let adjusts = []
    let adjust = []
    if (indata.datas !== undefined) {

        for (let index = 0; index < indata.datas.length; index++) {
            const kname = CLAPI.getData(indata, 'kname', index)
            if (kname === 'CG000000' || kname === 'CG000001') {
                continue
            }
            const code = CLAPI.getData(indata, 'code', index)
            const typename = transStyle(CLAPI.getData(indata, 'style', index))
            const bsflag = CLAPI.getData(indata, 'bsflag', index)
            const dirname = bsflag === 'B' ? '买' : '卖'
            const dirclr = bsflag === 'B' ? 'red' : 'green'
            // if (keyInfo[code] === undefined) {
            //     continue
            // }
            adjust = [
                adjusts.length + 1,
                code,
                code, // keyInfo[code].static.name,
                CLAPI.Utils.strMsecTostrDate(CLAPI.getData(indata, 'msecstamp', index)),
                CLAPI.Utils.strMsecTostrTime(CLAPI.getData(indata, 'msecstamp', index)),
                typename,
                dirname,
                dirclr,
            ]
            for (let fdi = 0; fdi < ARRAY_ADJUST.length; fdi++) {
                adjust.push(CLAPI.getData(indata, ARRAY_ADJUST[fdi], index))
            }
            adjusts.push(adjust)
        }
    }
    // console.log(adjusts);

    return { fields: FIELD_ADJUST, datas: adjusts }

}

export const FIELD_ADJUST_YS = {
    "kname": 0,
    "msecstamp": 1,
    "status": 2,
    "curprc": 3,
    "basket_idx": 4,
    "command": 5,
    "code": 6,
    "bsflag": 7,
    "curvol": 8,
    "simvol": 9,
    "adjvol": 10,
    "curfee": 11,
    "style": 12,
    "option": 13,
    "chmark": 14,
    "isort": 15,
    "irisk": 16,
    "ihold": 17,
    "fsort": 18,
    "frisk": 19,
    "fhold": 20,
    "scale": 21
}

// 从json转为标准adjust
export function getRealAdjust(newdata) {
    let adjusts = []
    let adjust = []
    if (newdata.infos !== undefined) {
        for (let index = 0; index < newdata.infos.length; index++) {
            const kname = newdata.infos[index].kname
            // console.log(kname);
            
            if (kname === 'CG000000' || kname === 'CG000001') {
                continue
            }
            adjust = [
                newdata.infos[index].kname,
                newdata.infos[index].msecstamp,
                newdata.infos[index].status,
                newdata.infos[index].curprc,
                newdata.infos[index].basket_idx,
                newdata.infos[index].command,
                newdata.infos[index].code,
                newdata.infos[index].bsflag,
                newdata.infos[index].curvol,
                newdata.infos[index].simvol,
                newdata.infos[index].adjvol,
                newdata.infos[index].curfee,
                newdata.infos[index].style,
                newdata.infos[index].option,
                newdata.infos[index].chmark,
                newdata.infos[index].isort,
                newdata.infos[index].irisk,
                newdata.infos[index].ihold,
                newdata.infos[index].fsort,
                newdata.infos[index].frisk,
                newdata.infos[index].fhold,
                newdata.infos[index].scale,
            ]
            adjusts.push(adjust)
        }
    }
    // console.log(adjusts);
    
    return { fields: FIELD_ADJUST_YS, datas: adjusts }

}

const FIELD_ASSETS = DATAS.fieldsToFieldsIndex('index,code,name,agovol,curclr,curvol,curavgp,curnewp,wreap,dreap,adjdate')

export function rpsRealAssets(curassets, newadjust, lastdate) {
    let infos = []
    let info = []
    let assets = 0
    console.log(curassets);
    
    function getAdjustIndex(code) {
        for (let index = 0; index < newadjust.datas.length; index++) {
            if (code === CLAPI.getData(newadjust, 'code', index)) {
                return index
            }
        }
        return -1
    }
    function getAssetsVol(code) {
        for (let index = 0; index < curassets.datas.length; index++) {
            if (code === CLAPI.getData(curassets, 'code', index)) {
                return 1
            }
        }
        return 0
    }
    for (let index = 0; index < curassets.datas.length; index++) {
        const code = CLAPI.getData(curassets, 'code', index)
        if (code === 'CI000000') {
            assets = CLAPI.getData(curassets, 'date', index)
            continue
        }
        const curdate = CLAPI.getData(curassets, 'date', index)
        const adjdate = CLAPI.getData(curassets, 'adjdate', index)
        const agovols = CLAPI.getData(curassets, 'curvol', index)
        let curclr = ''
        let curvols = agovols
        const curavgp = CLAPI.getData(curassets, 'curavgp', index)
        const curnewp = CLAPI.getData(curassets, 'curnewp', index)
        let wreap = (curnewp - curavgp) * curvols
        const dreap = wreap
        let adjvols = 0
        let adjcurp = 0
        const adjidx = getAdjustIndex(code)
        if (adjidx >= 0) {
            adjvols = CLAPI.getData(newadjust, 'adjvol', adjidx)
            adjcurp = CLAPI.getData(newadjust, 'curprc', adjidx)
            curvols = agovols - adjvols
            wreap = (adjcurp - curavgp) * adjvols - CLAPI.getData(newadjust, 'curfee', adjidx)
            curclr = 'green'
        }
        info = [
            infos.length + 1,
            code,
            code,
            agovols,
            curclr,
            curvols,
            curavgp,
            curnewp,
            wreap,
            dreap,
            adjdate
        ]
        infos.push(info)
    }
    for (let index = 0; index < newadjust.datas.length; index++) {
        const code = CLAPI.getData(newadjust, 'code', index);
        if (!getAssetsVol(code)) {
            infos.push([
                infos.length + 1,
                code,
                code,
                0,
                'red',
                CLAPI.getData(newadjust, 'adjvol', index),
                CLAPI.getData(newadjust, 'curprc', index),
                CLAPI.getData(newadjust, 'curprc', index),
                0.0,
                0.0,
                CLAPI.Utils.strMsecTostrDate(CLAPI.getData(newadjust, 'msecstamp', index)),
            ])
        }
    }
    if (lastdate === undefined) {
        let cur_holds = 0

    }
    return { fields: FIELD_ASSETS, datas: infos }
}
// const moneyinfos = 'date,cur_holds,cur_assets,cur_stks,dreapr,wreapr'

export function getInfoAssets(indata, keyInfo) {
    let infos = []
    let info = []
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        if (code === 'CI000000') {
            continue
        }
        const curdate = CLAPI.getData(indata, 'date', index)
        const adjdate = CLAPI.getData(indata, 'adjdate', index)
        const curvols = CLAPI.getData(indata, 'curvol', index)
        let agovols = 0
        if (curdate > adjdate) {
            agovols = curvols
        }
        const curavgp = CLAPI.getData(indata, 'curavgp', index)
        const curnewp = CLAPI.getData(indata, 'curnewp', index)
        const wreap = (curnewp - curavgp) * curvols
        const dreap = wreap
        info = [
            infos.length + 1,
            code,
            code,
            agovols,
            agovols === 0 ? 'red' : '',
            curvols,
            curavgp,
            curnewp,
            wreap,
            dreap,
            adjdate
        ]
        infos.push(info)
    }
    console.log(FIELD_ASSETS);

    return { fields: FIELD_ASSETS, datas: infos }

}

export function getInfoDetails(indata, keyInfo) {
    let adjusts = []
    let adjust = []
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        const typename = transStyle(CLAPI.getData(indata, 'style', index))
        adjust = [
            adjusts.length + 1,
            code,
            code, // keyInfo[code].static.name,
            CLAPI.Utils.strMsecTostrDate(CLAPI.getData(indata, 'msecstamp', index)),
            CLAPI.Utils.strMsecTostrTime(CLAPI.getData(indata, 'msecstamp', index)),
            typename,
        ]
        for (let fdi = 0; fdi < ARRAY_ADJUST.length; fdi++) {
            adjust.push(CLAPI.getData(indata, ARRAY_ADJUST[fdi], index))
        }
        adjusts.push(adjust)
    }
    return { fields: FIELD_ADJUST, datas: adjusts }

}
export const adjust_dreap_lines = [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value0'], // 参与计算最大值的标签
                minvalue: ['value0'] // 参与计算最小值的标签
            },
            info: { // 输出在信息栏目（title）的数据
                showstyle: 'zero',
                filled: true,
                label: '金额:',
                fieldY: 'value0', // 从key中获取对应的数据标签 用于显示信息用
                format: 'money',
            },
        }]

export const adjust_dhold_lines = [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value0'], // 参与计算最大值的标签
                minvalue: [0, 'value0'] // 参与计算最小值的标签
            },
            info: { // 输出在信息栏目（title）的数据
                // showstyle: 'zero',
                filled: true,
                label: '比例:',
                fieldY: 'value0', // 从key中获取对应的数据标签 用于显示信息用
                format: 'float',
            },
        }]

export function AdjustToData(indatas, valuename, summvname) {
    const fields = 'date,value0'

    let arrays = []
    for (let index = 0; index < indatas.datas.length; index++) {
        let value = CLAPI.getData(indatas, valuename, index)
        if (summvname !== undefined) {
            let summv = CLAPI.getData(indatas, summvname, index)
            value = value / summv
        }
        arrays.push([
            CLAPI.getData(indatas, 'date', index),
            value,
        ])
    }
    // console.log(arrays);
    return {
        fields: DATAS.fieldsToFieldsIndex(fields),
        datas: arrays,
    }
}

export function AdjustToDataRate(workers, indatas, valuename, sumname) {
    let fields = 'date'
    for (let index = 0; index < workers.datas.length; index++) {
        fields += ',value' + index.toString()
    }
    let arrays = []
    const onename = 'money0'
    for (let index = 0; index < indatas[onename].datas.length; index++) {
        let array = [CLAPI.getData(indatas[onename], 'date', index)]
        for (let wi = 0; wi < workers.datas.length; wi++) {
            const curname = 'money' + wi.toString()
            const v1 = CLAPI.getData(indatas[curname], valuename, index)
            const v0 = CLAPI.getData(indatas[curname], sumname, index)
            array.push(v1 / v0 * 100.0)
        }
        arrays.push(array)
    }
    // console.log(arrays);
    return {
        fields: DATAS.fieldsToFieldsIndex(fields),
        datas: arrays,
    }
}
export function AdjustGetKey(stocks) {
    // let kidx = 0
    // if (indata && indata.datas !== undefined) {
    //     for (let index = 0; index < indata.datas.length; index++) {
    //         const kname = CLAPI.getData(indata, 'kname', index)
    //         console.log(kname);
            
    //         if (kname === 'CG000000' || kname === 'CG000001') {
    //             continue
    //         }
    //         if (kidx === 0) {
    //             return kname;
    //         }
    //         kidx--;
    //     }
    // }
    // console.log(stocks);
    
    return CLAPI.getData(stocks, 'code', -1)
}

export function AdjustGetLines(nums, aidx, format) {
    let lines = []
    let lindex = 0
    for (let index = 0; index < nums; index++) {
        if (aidx === -1 || (aidx === index)) {
            lines.push({
                className: CLAPI.ClDrawZLine,
                extremum: { // 如何取极值
                    method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                    maxvalue: ['value' + lindex.toString()], // 参与计算最大值的标签
                    minvalue: ['value' + lindex.toString()] // 参与计算最小值的标签
                },
                info: { // 输出在信息栏目（title）的数据
                    label: 'V' + lindex.toString() + ':',
                    fieldY: 'value' + lindex.toString(), // 从key中获取对应的数据标签 用于显示信息用
                    format: format === undefined ? 'money' : format,
                },
            })
            lindex++
        }
    }
    return lines
}

export const CHART_ADJUST_INFOS = {
    style: 'horizontal', // 'vertical'
    maxchs: 8,
    ctrls: [{
        clickValue: 'adjust',
        label: '当日调仓',
    },
    {
        clickValue: 'assets',
        label: '当日持仓',
    },
    {
        clickValue: 'census',
        label: '个股统计',
    },
    {
        clickValue: 'details',
        label: '个股明细',
    },
    ]
}

export const CHART_MONEY_HEAD = {
    title: {
        label: 'head',
        display: 'text' // none 不显示 btn 按钮 text 文字
    },
    axisX: {
        lines: 0,
        display: 'none',
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'none', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal',   // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'money',  // 输出数据的格式 rate, price, vol money
            getclr: 'zero',
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal',  // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'money',  // rate, price vol
            getclr: 'zero',
        }
    },
    lines: []
}

export const CHART_MONEY_FOOT = {
    title: {
        label: 'foot',
        display: 'text' // none 不显示 btn 按钮 text 文字
    },
    axisX: {
        display: 'normal',
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'none',    // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal',   // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'money',    // 输出数据的格式 rate, price, vol money
            getclr: 'zero',
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'normal',  // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'money',  // rate, price vol
            getclr: 'zero',
        }
    },
    lines: []
}

export const AdjustInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string',
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    // {
    //     label: "名称",
    //     field: 'name',
    //     maxchs: 8,
    //     align: 'left',  // alignTxt 默认为'right'
    //     sort: 'resume', 
    //     getclr : 'getNameClr',
    //     getvar : 'getStrVar',  
    // },
    {
        label: '时间',
        field: 'time',
        maxchs: 4,
        align: 'left',  // alignTxt 默认为'right'
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    {
        label: '方向',
        maxchs: 3,
        field: 'dirname',
        fieldclr : 'dirclr',
        align: 'center', // align 默认为'right'
        getvar: 'getStrVar',
    },
    {
        label: '类型',
        maxchs: 4,
        align: 'center',
        field: 'typename',
        getclr: 'getIntClr',
        getvar: 'getStrVar',
    },
    {
        label: '最新',
        maxchs: 5,
        field: 'curprc',
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    },
    {
        label: '当前量',
        maxchs: 6,
        field: 'curvol',
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '调仓量',
        maxchs: 6,
        field: 'adjvol',
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '收益因子',
        maxchs: 7,
        field: 'fsort',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '风险因子',
        maxchs: 7,
        field: 'frisk',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '持仓因子',
        maxchs: 7,
        field: 'fhold',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '仓位比例',
        maxchs: 7,
        field: 'scale',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '手续费',
        field: 'curfee',
        getclr: 'getFltClr',
        getvar: 'getFltVar',
    },
    {
        label: '成交额',
        field: 'curmny',
        getclr: 'getMnyClr',
        getvar: 'getMnyVar',
    },
];

export const CensusInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string',
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    // {
    //     label: "名称",
    //     field: 'name',
    //     maxchs: 8,
    //     align: 'left',  // alignTxt 默认为'right'
    //     sort: 'resume', 
    //     getclr : 'getNameClr',
    //     getvar : 'getStrVar',  
    // },
    {
        label: '次数',
        maxchs: 3,
        field: 'sumnum',
        getclr: 'getVolClr',
        getvar: 'getIntVar',
    },
    {
        label: '胜率',
        field: 'winrate',
        getclr: 'getZeroClr',
        getvar: 'getPctVar',
    },
    {
        label: '总收益',
        field: 'wreap',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '收益率',
        field: 'wreapr',
        getclr: 'getZeroClr',
        getvar: 'getPctVar',
    },
];

export const DetailsInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string',
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    // {
    //     label: "名称",
    //     field: 'name',
    //     maxchs: 8,
    //     align: 'left',  // alignTxt 默认为'right'
    //     sort: 'resume', 
    //     getclr : 'getNameClr',
    //     getvar : 'getStrVar',  
    // },
    {
        label: '日期',
        field: 'date',
        maxchs: 7,
        align: 'left',  // alignTxt 默认为'right'
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    {
        label: '时间',
        field: 'time',
        maxchs: 4,
        align: 'left',  // alignTxt 默认为'right'
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    {
        label: '方向',
        maxchs: 3,
        field: 'dirname',
        fieldclr : 'dirclr',
        align: 'center', // align 默认为'right'
        getvar: 'getStrVar',
    },
    {
        label: '类型',
        maxchs: 4,
        align: 'center',
        field: 'typename',
        getclr: 'getIntClr',
        getvar: 'getStrVar',
    },
    {
        label: '最新',
        maxchs: 4,
        field: 'curprc',
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    },
    {
        label: '当前量',
        maxchs: 6,
        field: 'curvol',
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '调仓量',
        maxchs: 6,
        field: 'adjvol',
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '收益因子',
        maxchs: 6,
        field: 'fsort',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '风险因子',
        maxchs: 6,
        field: 'frisk',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '持仓因子',
        maxchs: 6,
        field: 'fhold',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '仓位比例',
        maxchs: 6,
        field: 'scale',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: '手续费',
        field: 'curfee',
        getclr: 'getFltClr',
        getvar: 'getFltVar',
    },
    {
        label: '成交额',
        field: 'curmny',
        getclr: 'getMnyClr',
        getvar: 'getMnyVar',
    },
];

export const AssetsInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 3,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string',
        getclr: 'getCodeClr',
        getvar: 'getStrVar',
    },
    // {
    //     label: "名称",
    //     field: 'name',
    //     maxchs: 8,
    //     align: 'left',  // alignTxt 默认为'right'
    //     sort: 'resume', 
    //     getclr : 'getNameClr',
    //     getvar : 'getStrVar',  
    // },
    {
        label: '平均成本',
        maxchs: 7,
        field: 'curavgp',
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    },
    {
        label: '最新价',
        maxchs: 6,
        field: 'curnewp',
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    },
    {
        label: '当前量',
        maxchs: 6,
        fieldclr : 'curclr',
        field: 'curvol',
        // getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    {
        label: '期初量',
        maxchs: 6,
        field: 'agovol',
        getclr: 'getIntClr',
        getvar: 'getIntVar',
    },
    // {
    //     label: '当日收益',
    //     field: 'dreap',
    //     getclr : 'getZeroClr', 
    //     getvar : 'getFltVar', 
    // },
    {
        label: '总收益',
        field: 'wreap',
        getclr: 'getZeroClr',
        getvar: 'getFltVar',
    },
    {
        label: "买入日期",
        field: 'adjdate',
        maxchs: 8,
        getclr : 'getIntClr',
        getvar : 'getIntsVar',  
    },
];

export const CHART_BOARD_ADJUST = {
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 3,
            rows: [{
                cols: [{
                    align: 'left',
                    maxchs: 4,
                    label: '开始',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'opendate',
                    clr: 'txt',
                },
                {
                    align: 'left',
                    maxchs: 4,
                    label: '结束',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'stopdate',
                    clr: 'txt',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '起始资金',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'openmny',
                    getclr: 'getMnyClr',
                    getvar: 'getVolVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '结束资产',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'stopmny',
                    getclr: 'getMnyClr',
                    getvar: 'getVolVar',
                },
                ]
            },
            {
                cols: [{
                    align: 'left',
                    maxchs: 4,
                    label: '盈亏',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'reaprate',
                    getclr: 'getZeroClr',
                    getvar: 'getPctVar',
                },
                {
                    align: 'left',
                    maxchs: 4,
                    label: '收益',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'reapmny',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最大盈利',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'maxreap',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最大回撤',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'minreap',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                ]
            },
            {
                cols: [{
                    align: 'left',
                    maxchs: 4,
                    label: '胜率',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'wwinrate',
                    getclr: 'getPrcClr',
                    getvar: 'getPctVar',
                },
                {
                    align: 'left',
                    maxchs: 4,
                    label: '夏普',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'sharp',
                    clr: 'txt',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '个股胜率',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'mwinrate',
                    getclr: 'getPrcClr',
                    getvar: 'getPctVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '持仓周期',
                    clr: 'label',
                },
                {
                    maxchs: 7,
                    field: 'holddays',
                    getvar: 'getIntVar',
                    clr: 'txt',
                    getvar: 'getFltVar',
                },
                ]
            },
            ],
        },
    }
}

export const CHART_BOARD_STOCK = {
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'text',
        spaceY: 3,
        spaceX: 4,
        rows: [{
            cols: [{
                align: 'left',
                maxchs: 8,
                field: 'name',
                pixel: 16,
                clr: 'name',
                getvar: 'getStrVar',
                getclr: 'getNameClr',
            },
            {
                maxchs: 6,
                field: 'code',
                pixel: 15,
                clr: 'code',
                getvar: 'getStrVar',
                getclr: 'getCodeClr',
            },
            {
                align: 'left',
                maxchs: 6,
                label: '收益率',
                clr: 'label',
            },
            {
                maxchs: 6,
                field: 'profitr',
                getclr: 'getZeroClr',
                getvar: 'getPctVar',
            },
            {
                align: 'left',
                maxchs: 4,
                label: '收益',
                clr: 'label',
            },
            {
                maxchs: 6,
                field: 'profit',
                getclr: 'getZeroClr',
                getvar: 'getIntVar',
            },
            {
                align: 'left',
                maxchs: 4,
                label: '胜率',
                clr: 'label',
            },
            {
                maxchs: 6,
                field: 'winrate',
                getclr: 'getVolClr',
                getvar: 'getPctVar',
            },
            ]
        }
        ],
    },
}

export function getWinmny(indata) {
    let wwokmny = 0;
    let wwnomny = 0;
    let codeinfo = {}
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        const adjvol = CLAPI.getData(indata, 'adjvol', index)
        const adjmny = CLAPI.getData(indata, 'adjmny', index)
        const adjfee = CLAPI.getData(indata, 'adjfee', index)
        if (codeinfo[code] === undefined) {
            codeinfo[code] = {
                curprc: CLAPI.getData(indata, 'curavgp', index),
                curnew: CLAPI.getData(indata, 'curnewp', index),
                curvol: adjvol,
                bidmny: adjmny + adjfee,
            }
        }
        else {
            if (adjvol > 0) {
                // 增加股票
                codeinfo[code].curprc = CLAPI.getData(indata, 'curavgp', index),
                codeinfo[code].curnew = CLAPI.getData(indata, 'curnewp', index),
                codeinfo[code].curvol = adjvol
                codeinfo[code].bidmny = adjmny + adjfee
            }
            else if (adjvol < 0) {
                // 结束股票
                const askmny = adjmny - adjfee
                wwokmny += askmny - codeinfo[code].bidmny
                codeinfo[code].curprc = 0
                codeinfo[code].curnew = 0
                codeinfo[code].curvol = 0
            } 
            else {
                codeinfo[code].curprc = CLAPI.getData(indata, 'curavgp', index)
                codeinfo[code].curnew = CLAPI.getData(indata, 'curnewp', index)
                codeinfo[code].curvol = CLAPI.getData(indata, 'curvol', index)
            } 
        }
    }
    Object.values(codeinfo).forEach(curcode => {
        if (curcode.curvol > 0) {
            wwnomny += (curcode.curnew - curcode.curprc) * curcode.curvol * 0.9993
        }
    });
    console.log("winmny: ", wwokmny, wwnomny, wwokmny + wwnomny);
    return wwokmny + wwnomny
}
const adjustinfos = 'opendate,stopdate,openmny,stopmny,reaprate,reapmny,maxreap,minreap,wwinrate,sharp,mwinrate,holddays'
export function getadjustInfo(moneys, codeinfo) {
    // console.log(moneys);
    // console.log(stocks);
    const openmny = CLAPI.getData(moneys, 'ago_assets', 0)
    const stopmny = CLAPI.getData(moneys, 'cur_assets', -1)
    const wfeemny = 0 // CLAPI.getData(moneys, 'wfeem', -1)

    const dreaps = DATAS.extractField(moneys, 'dreap')
    // console.log(dreaps);
    let maxmny = dreaps[0]
    let minmny = dreaps[0]
    let upnums = 0
    let dnnums = 0
    // 遍历数组计算结果
    for (const curmny of dreaps) {
        // // 检查元素是否为有效数字
        // if (typeof num !== 'number' || isNaN(num)) {
        //     throw new Error("数组中包含非数字元素");
        // }        
        // 更新最大值
        if (curmny > maxmny) {
            maxmny = curmny;
        }
        // 更新最小值
        if (curmny < minmny) {
            minmny = curmny;
        }
        // 统计大于0的元素
        if (curmny > 0) {
            upnums++;
        }
        if (curmny < 0) {
            dnnums++;
        }
    }
    let sharp = DATAS.calculateSharpeRatio(dreaps, true)
    // 下面统计股票的信息
    let sumnum = 0
    let winnum = 0
    let sumday = 0
    if (codeinfo !== undefined) {
        Object.values(codeinfo).forEach(curcode => {
            sumnum += curcode.sumnum
            winnum += curcode.winnum
            sumday += curcode.sumday
        });
        winnum = winnum / sumnum
        sumday = sumday / sumnum
    }

    return {
        fields: DATAS.fieldsToFieldsIndex(adjustinfos),
        datas: [[
            CLAPI.getData(moneys, 'date', 0),
            CLAPI.getData(moneys, 'date', -1),
            openmny,
            stopmny - wfeemny,
            (CLAPI.getData(moneys, 'wreap', -1) - wfeemny) / openmny,
            (CLAPI.getData(moneys, 'wreap', -1) - wfeemny),
            maxmny,
            minmny,
            upnums / (upnums + dnnums),
            sharp,
            winnum,
            sumday,
        ]],
    }
}
export function getCodeInfo(indata) {
    let codeinfo = {}
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        const adjmny = CLAPI.getData(indata, 'adjmny', index)
        const adjfee = CLAPI.getData(indata, 'adjfee', index)
        if (codeinfo[code] === undefined) {
            codeinfo[code] = {
                curmny: adjmny + adjfee,
                bidmny: adjmny + adjfee,
                sumnum: 0,
                winnum: 0,
                winmny: 0,
                curday: 1,
                sumday: 1
            }
        }
        else {
            const adjvol = CLAPI.getData(indata, 'adjvol', index)
            if (adjvol > 0) {
                // 增加股票
                codeinfo[code].bidmny += adjmny + adjfee,
                    codeinfo[code].curmny = adjmny + adjfee,
                    codeinfo[code].curday = 1
            }
            else if (adjvol < 0) {
                // 结束股票
                const askmny = adjmny - adjfee
                codeinfo[code].sumnum++;
                codeinfo[code].sumday += codeinfo[code].curday;
                if (askmny > codeinfo[code].curmny) {
                    codeinfo[code].winnum++;
                }
                codeinfo[code].winmny += CLAPI.getData(indata, 'sreap', index)
                // 初始化数据
                codeinfo[code].curmny = 0
                codeinfo[code].curday = 0
            }
            else if (adjvol === 0) {
                codeinfo[code].curday++
            }
        }
    }
    return codeinfo
}
const centusinfos = 'index,code,name,sumnum,winnum,winrate,wreap,wreapr'
export function getInfoCensus(codeinfo) {
    let infos = []
    let index = 0
    Object.keys(codeinfo).forEach(code => {
        infos.push([
            index++,
            code,
            code,
            codeinfo[code].sumnum,
            codeinfo[code].winnum,
            codeinfo[code].winnum / codeinfo[code].sumnum,
            codeinfo[code].winmny,
            codeinfo[code].winmny / codeinfo[code].bidmny,
        ])
    });
    return {
        fields: DATAS.fieldsToFieldsIndex(centusinfos),
        datas: infos
    }
}

const stockinfos = 'code,name,profit,profitr,winrate'
export function getstockInfo(keyInfo, adjust) {
    // console.log(adjust);

    let curbid = 0.0
    let curask = 0.0
    let bidmny = 0.0
    let askmny = 0.0
    let sumnum = 0
    let winnum = 0
    for (let index = 0; index < adjust.datas.length; index++) {
        // CLAPI.Utils.strMsecTostrTime(CLAPI.getData(adjust, 'msecstamp', index))
        const flag = CLAPI.getData(adjust, 'bsflag', index)
        if (flag === 'B') {
            curbid = CLAPI.getData(adjust, 'curprc', index) * CLAPI.getData(adjust, 'adjvol', index) + CLAPI.getData(adjust, 'curfee', index)
        }
        if (flag === 'S') {
            curask = CLAPI.getData(adjust, 'curprc', index) * Math.abs(CLAPI.getData(adjust, 'adjvol', index)) - CLAPI.getData(adjust, 'curfee', index)
            bidmny += curbid
            askmny += curask
            sumnum++;
            // console.log(curbid, curask);

            if (curask > curbid) {
                winnum++;
            }
            curbid = 0
            curask = 0
        }
    }
    let summny = askmny - bidmny;

    return {
        fields: DATAS.fieldsToFieldsIndex(stockinfos),
        datas: [[
            CLAPI.getData(keyInfo, 'code', -1),
            CLAPI.getData(keyInfo, 'name', -1),
            summny,
            summny / bidmny,
            winnum / sumnum]],
    }
}


/////////////////////
//  phone
////////////////////

export const FHEIGHT = 80

const moneyinfos = 'date,cur_holds,cur_assets,cur_stks,dreapr,wreapr'
export function moneyToDateinfo(indata) {
    let infos = []
    const initassets = CLAPI.getData(indata, 'ago_assets', 0)     
    for (let index = indata.datas.length - 1; index >= 0; index--) {
        const cdate = CLAPI.getData(indata, 'date', index)
        const drate = CLAPI.getData(indata, 'dreap', index) / CLAPI.getData(indata, 'cur_assets', index)
        const wrate = (CLAPI.getData(indata, 'wreap', index)) / initassets
        infos.push([
            cdate,
            CLAPI.getData(indata, 'cur_holds', index),
            CLAPI.getData(indata, 'cur_assets', index),
            CLAPI.getData(indata, 'cur_stks', index),
            drate,
            wrate,
        ])
    }
    return {
        fields: DATAS.fieldsToFieldsIndex(moneyinfos),
        datas: infos
    }
}

export function incrNewDateinfo(indata, nowdate) {
    const lastinfo = indata.datas[0]
    if (nowdate > lastinfo[0]) {
        indata.newdate = nowdate
        indata.datas.unshift([
            nowdate,
            lastinfo[1],
            lastinfo[2],
            0.0,
            0.0,
            0.0,
        ])
    }
}

export const CHART_PHONE_INFOS = {
    style: 'horizontal', // 'vertical'
    maxchs: 8,
    ctrls: [{
        clickValue: 'adjust',
        label: '当日调仓',
    },
    {
        clickValue: 'assets',
        label: '当日持仓',
    },
    ]
}

export const CHART_BOARD_PHONE = {
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: FHEIGHT * 0.2,
            pixel:  FHEIGHT * 0.5,
            rows: [
            {
                cols: [
                {
                    align: 'left',
                    maxchs: 8,
                    label: '开始日期',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'opendate',
                    clr: 'txt',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最新日期',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'stopdate',
                    clr: 'txt',
                }
                ]
            },
            {
                cols: [
                {
                    align: 'left',
                    maxchs: 8,
                    label: '起始资金',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'openmny',
                    getclr: 'getMnyClr',
                    getvar: 'getVolVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最新资产',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'stopmny',
                    getclr: 'getMnyClr',
                    getvar: 'getVolVar',
                },
                ]
            },
            {
                cols: [
                {
                    align: 'left',
                    maxchs: 8,
                    label: '盈亏比例',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'reaprate',
                    getclr: 'getZeroClr',
                    getvar: 'getPctVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最新收益',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'reapmny',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                ]
            },
            {
                cols: [
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最大盈利',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'maxreap',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '最大回撤',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'minreap',
                    getclr: 'getZeroClr',
                    getvar: 'getVolVar',
                },
                ]
            },
            {
                cols: [
                {
                    align: 'left',
                    maxchs: 8,
                    label: '盈亏比率',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'wwinrate',
                    getclr: 'getPrcClr',
                    getvar: 'getPctVar',
                },
                {
                    align: 'left',
                    maxchs: 8,
                    label: '夏普比例',
                    clr: 'label',
                },
                {
                    maxchs: 8,
                    field: 'sharp',
                    clr: 'txt',
                },
                ]
            },
            ],
        },
    }
}


